import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const EventCard = ({ event }) => {
  const navigate = useNavigate();
  const formatDate = (date) => {
    let d = new Date(date);
    let dateString = d.toDateString();
    let hours = d.getHours();
    let minutes = d.getMinutes();

    let timeString;
    if (hours > 12 && minutes === 0) {
      timeString = `${hours - 12} PM`;
    } else if (hours > 12 && minutes > 0) {
      timeString = `${hours - 12}:${minutes} PM`;
    } else if (hours <= 12 && minutes === 0) {
      timeString = `${hours} AM`;
    } else if (hours <= 12 && minutes > 0) {
      timeString = `${hours}:${minutes} AM`;
    }

    return `${dateString} @ ${timeString}`;
  };

  const renderEventType = (event) => {
    if (event?.eventType !== "Pairing") {
      return <Typography>{event?.eventType}</Typography>;
    } else if (event?.eventType === "Pairing" && event?.pairingEventType) {
      return <Typography>{event?.pairingEventType}</Typography>;
    } else if (event?.eventType === "Pairing" && !event?.pairingEventType) {
      return (
        <Button
          variant="outlined"
          size="small"
          sx={{
            borderColor: "red",
            color: "red",
            "&:hover": {
              borderColor: "darkred",
              backgroundColor: "rgba(255, 0, 0, 0.1)",
            },
          }}
          onClick={() =>
            navigate(`/eventcontroller/${event._id}`, { state: { event } })
          }
        >
          Assign Event Type
        </Button>
      );
    }
    return <></>;
  };

  const renderEventProfile = (event) => {
    if (event?.eventType === "Pairing" && event?.questionGroup) {
      return <Typography>{event?.questionGroup}</Typography>;
    } else if (event?.eventType === "Pairing" && !event?.questionGroup) {
      return (
        <Button
          variant="outlined"
          size="small"
          sx={{
            borderColor: "red",
            color: "red",
            "&:hover": {
              borderColor: "darkred",
              backgroundColor: "rgba(255, 0, 0, 0.1)",
            },
          }}
          onClick={() =>
            navigate(`/eventcontroller/${event._id}`, { state: { event } })
          }
        >
          Assign Event Profile
        </Button>
      );
    }
    return <></>;
  };

  return (
    <Grid
      item
      key={event.name}
      md={4}
      sm={4}
      xs={12}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <Card sx={{ width: 345, maxHeight: 350 }} variant="outlined">
        <CardMedia
          sx={{ height: 140 }}
          image={event.imageUrl}
          title={event.name}
          style={{cursor: 'pointer'}}
          onClick={() =>
            navigate(`/eventcontroller/${event._id}`, { state: { event } })
          }
        />
        <CardContent>
          <Typography gutterBottom variant="body1" component="div">
            {event.name}
          </Typography>
          <Typography variant="subtitle2" style={{ color: "#6e0101" }}>
            {formatDate(event.date)}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {event.description}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "auto", // Pushes the actions to the bottom
          }}
        >
          {renderEventType(event)}
          {renderEventProfile(event)}
        </CardActions>
      </Card>
    </Grid>
  );
};

export default EventCard;
